<section class="operations-page">
    <header class="operations-page__header">
        <div>
            <h2 class="operations-page__title">Provider Events</h2>
            <p class="operations-page__lead">Normalized provider event explorer without raw payload exposure.</p>
        </div>
    </header>

    <div class="operations-page__card">
        <app-filter-bar
                [filters]="filterDefinitions"
                [values]="filterValues"
                (apply)="onFiltersApply($event)"
                (reset)="onFiltersReset()"
        ></app-filter-bar>

        <p class="operations-page__loading" *ngIf="listState.loading">Loading provider events…</p>

        <div class="operations-table-wrapper" *ngIf="!listState.loading">
            <table class="operations-table">
                <thead>
                <tr>
                    <th>S.No</th>
                    <th *ngIf="showOrganizationColumn">Organization</th>
                    <th *ngFor="let column of sortableColumns"
                        class="operations-table__sortable"
                        (click)="onSort(column.key)">
                        {{ column.label }}
                        <span class="sort-indicator">{{ sortIndicator(column.key) }}</span>
                    </th>
                    <th>Camera</th>
                    <th>Normalized Preview</th>
                    <th>Transaction</th>
                    <th class="operations-table__actions"></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="!events.length">
                    <td [attr.colspan]="showOrganizationColumn ? 10 : 9" class="operations-table__empty">No provider
                        events found.
                    </td>
                </tr>
                <tr *ngFor="let event of events; let i = index">
                    <td>{{ serialNumber(i) }}</td>
                    <td *ngIf="showOrganizationColumn">{{ organizationLabel(event.organization_id) }}</td>
                    <td>{{ formatTimestamp(event.received_at) }}</td>
                    <td>
                        <app-provider-event-status-badge
                                [status]="event.processing_status"></app-provider-event-status-badge>
                    </td>
                    <td>{{ providerLabel(event.provider_id) }}</td>
                    <td>{{ formatTimestamp(event.provider_timestamp) }}</td>
                    <td>{{ event.camera_id ?? '—' }}</td>
                    <td>{{ normalizedPreview(event) }}</td>
                    <td>
                        <a *ngIf="event.matched_transaction_id as transactionId"
                           class="operations-table__link"
                           [routerLink]="['/operations/transactions', transactionId]">View TX</a>
                        <span *ngIf="!event.matched_transaction_id">—</span>
                    </td>
                    <td class="operations-table__actions">
                        <a class="operations-table__link"
                           [routerLink]="['/operations/provider-events', event.id]"
                           [queryParams]="eventDetailQueryParams(event)">View</a>
                    </td>
                </tr>
                </tbody>
            </table>

            <app-vte-pagination
                    [currentPage]="listState.currentPage"
                    [pageSize]="listState.pageSize"
                    [totalRecords]="listState.totalRecords"
                    [showJumpToPage]="true"
                    (pageChange)="onPageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)"
            ></app-vte-pagination>
        </div>
    </div>
</section>
